/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 12/21/15.
 */
'use strict';
angular.module('prism-ui.components').controller('ProxyPlayerController', function (
    $rootScope,
    $scope,
    $sce,
    EndPointService,
    ProxyPlayerService
) {
    var self = this;

    // hard-coded MIME types - these are a safe bet for now given
    // current HTML5 format support
    const MimeTypeAudioMp3 = 'audio/mp3';
    const MimeTypeVideoMp4 = 'video/mp4';
    const MimeTypeTextVtt = 'text/vtt';

    self.config = {
        sources: [{
            src: '',
            type: MimeTypeVideoMp4
        }],
        autoHide: true,
        autoHideTime: 3000,
        tracks: [{
            src: '',
            default: true,
            type: MimeTypeTextVtt
        }],
        cuePoints: self.cuePoints,
        plugins: {
            poster: self.posterPath
        }
    };

    self.onPlayerReady = function (API) {
        self.API = API;
    };

    self.onUpdateTime = function (currentTime, duration) {
        ProxyPlayerService.playerTime = currentTime;
        if (ProxyPlayerService.onTimeUpdate) {
            ProxyPlayerService.onTimeUpdate(currentTime, duration);
        }
    };

    self.onUpdateState = function (state) {
        if (ProxyPlayerService.onChangedState) {
            ProxyPlayerService.onChangedState(state);
        }
    };

    ProxyPlayerService.seek = function (seekValue) {
        self.API.seekTime(seekValue);
    };
    ProxyPlayerService.stop = function () {
        self.API.stop();
    };
    ProxyPlayerService.pause = function () {
        self.API.pause();
    };
    ProxyPlayerService.play = function () {
        self.API.play();
    };

    $scope.$watch(function () {
            return self.media;
        },
        function (newVal) {
            if (newVal && newVal !== '') {
                self.API.stop();
                self.config.sources = [{
                    src: $sce.trustAsResourceUrl(self.media.mediaPath),
                    type: self.isAudio ? MimeTypeAudioMp3 : MimeTypeVideoMp4
                }];
            }
        });

    $scope.$watch(function () {
            return self.cuePoints;
        },
        function (newVal, oldVal) {
            if (newVal !== oldVal) {
                self.config.cuePoints = newVal;
            }
        });

    $scope.$watch(function () {
            return self.ccSubtitle;
        },
        function (newVal) {
            if (newVal && newVal !== '') {
                self.config.tracks = [{
                    src: $sce.trustAsResourceUrl(self.ccSubtitle.mediaPath),
                    default: true,
                    type: MimeTypeTextVtt,
                    label: newVal
                }];
            } else {
                self.config.tracks = [];
            }
        });
});
